<template>
<div class="preferences-values">
  <Tag v-for="item in values" :key="item" :name="item" closable @on-close="handleClose">
     {{ item }}
  </Tag>
  <div class="preferences-values__addbtn">
    <Input v-model.trim="inputValue" size="small" @on-enter="handleAdd">
      <Button slot="append" type="dashed" size="small" @click="handleAdd">{{$t('pages_combo_index_284')}}</Button>
    </Input>
  </div>
</div>
</template>

<script>
import i18n from '../../../../locales/index'

import { isEqual } from 'lodash';
import { preferencesValuesValidate } from '@/libs/validate';
export default {
  name: 'PreferencesValues',
  components: {},
  props: ['value'],
  data () {
    return {
      values: [],
      inputValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (isEqual(val, this.values)) return;
        if (!val) {
          this.inputValue = ''
        }
        this.values = val || [];
      },
    },
  },
  methods: {
    handleAdd () {
      preferencesValuesValidate({
        inputValue: this.inputValue,
        values: this.values
      }).then(() => {
        console.log('测试');
        this.values.push(this.inputValue);
        this.$emit('input', this.values);
        this.inputValue = '';
      })
    },
    handleClose (event, name) {
      const index = this.values.indexOf(name);
      this.values.splice(index, 1);
      this.$emit('input', this.values);
    }
  }
}
</script>
<style lang='scss' scoped>
.preferences-values {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  padding-top: 4px;
  &__addbtn {
    display: inline-block;
    width: 100px;
  }
}
</style>
